<script setup lang="ts">
/**
 * UI-kit component
 * Category: Tables
 * Name: 'AppTh'
 */

defineOptions({
  name: 'AppTh',
})
</script>

<template>
  <th class="app-th">
    <slot />
  </th>
</template>

<style lang="scss" scoped src="../styles/_app-table.scss" />
